.form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}
